import React from "react";
import { ReactComponent as ReservoirIcon } from "../components/icons/partners/reservoir.svg";
import { ReactComponent as AltitudeIcon } from "../components/icons/partners/altitude.svg";
import { ReactComponent as CowSwapIcon } from "../components/icons/partners/cowswap.svg";
// import { ReactComponent as DineroIcon } from "../components/icons/partners/dinero.svg";
// import { ReactComponent as ElixirIcon } from "../components/icons/partners/elixir.svg";
import { ReactComponent as NucleusIcon } from "../components/icons/partners/nucleus.svg";
import { ReactComponent as M0Icon } from "../components/icons/partners/m0.svg";
import { ReactComponent as GammaSwapIcon } from "../components/icons/partners/gammaswap.svg";
import { ReactComponent as SonicIcon } from "../components/icons/partners/sonic.svg";
import { ReactComponent as EtherfiIcon } from "../components/icons/partners/etherfi.svg";
// import { ReactComponent as UsualIcon } from "../components/icons/partners/usual.svg";
// import { ReactComponent as LevelIcon } from "../components/icons/partners/level.svg";
import { ReactComponent as MorphoIcon } from "../components/icons/partners/morpho.svg";
import { ReactComponent as OpenEdenIcon } from "../components/icons/partners/openEden.svg";
import { ReactComponent as PendleIcon } from "../components/icons/partners/pendle.svg";
import { ReactComponent as SherlockIcon } from "../components/icons/partners/sherlock.svg";
import { ReactComponent as LayerZeroIcon } from "../components/icons/partners/layerzero.svg";
import { ReactComponent as FxProtocolIcon } from "../components/icons/partners/fxProtocol.svg";
// import { ReactComponent as StreamIcon } from "../components/icons/partners/stream.svg";
import { ReactComponent as PlumeIcon } from "../components/icons/partners/plume.svg";
import { ReactComponent as SwellIcon } from "../components/icons/partners/swell.svg";
import { ReactComponent as SpearbitIcon } from "../components/icons/partners/spearbit.svg";

export function Partners() {
    const partnersList = [
        PendleIcon,
        EtherfiIcon,
        OpenEdenIcon,
        // DineroIcon,
        ReservoirIcon,
        M0Icon,
        NucleusIcon,
        // LevelIcon,
        // ElixirIcon,
        LayerZeroIcon,
        // UsualIcon,
        SonicIcon,
        GammaSwapIcon,
        CowSwapIcon,
        SherlockIcon,
        SpearbitIcon,
        MorphoIcon,
        // StreamIcon,
        PlumeIcon,
        FxProtocolIcon,
        SwellIcon,
        AltitudeIcon
    ]


    return (
        <section id="assets" aria-label="Supported Assets">
            <div className='wrapper px-5'>
                <div className='w-2/5 h-2/5 rounded-full blur-[330px] bg-primary absolute bottom-72 z-10 max-sm:bottom-80'/>
                <h2 className='z-20'>Our Partners</h2>
                <div className="flex flex-row justify-center items-center flex-wrap relative gap-14 max-w-4xl">
                    {partnersList.map((Icon, index) => (
                        <Icon
                            key={index}
                            className='text-[#888C98]'
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}
export default Partners
